.root {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background: var(--rec-color-brand-surface);
  border: 1px solid #ddd6fe;
  border-radius: 8px;
}

.head {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.head-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--rec-color-purple-fg);
}

.head-sub {
  font-size: 9px;
  color: #94a3b8;
}

.divider {
  height: 1px;
  background: #ddd6fe;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.section-head {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.section-title {
  font-size: 10px;
  font-weight: 700;
  color: var(--rec-color-purple-fg);
  letter-spacing: 0.3px;
}

.section-hint {
  flex: 1;
  min-width: 0;
  font-size: 9px;
  color: #94a3b8;
}

.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  padding: 1px 6px;
  border-radius: 8px;
  background: var(--rec-color-purple-dot);
  color: var(--rec-color-background);
  font-size: 9px;
  font-weight: 700;
}

.chevron {
  flex: none;
  display: inline-flex;
  color: var(--rec-color-purple-dot);
}

.weight-rows {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.weight-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}

.weight-tag-col {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: none;
  width: 88px;
}

.weight-tag {
  font-size: 9px;
  font-weight: 600;
}

.weight-tag-is-brief {
  color: #065f46;
}

.weight-tag-is-manual {
  color: var(--rec-color-purple-fg);
}

.weight-pct {
  font-size: 8px;
  font-weight: 500;
  color: #94a3b8;
}

.weight-input {
  flex: 1;
  min-width: 0;
  height: 12px;
  cursor: pointer;
}

.weight-input-is-brief {
  accent-color: #10b981;
}

.weight-input-is-manual {
  accent-color: var(--rec-color-purple-dot);
}

.weight-remove {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #a78bfa;
}

.weight-remove-is-brief {
  color: #34d399;
}

.search {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  background: var(--rec-color-background);
  border: 1px solid #ddd6fe;
  border-radius: 6px;
  color: #94a3b8;
}

.search-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font: inherit;
  font-size: 9px;
  color: var(--rec-color-btn-dark);
  outline: none;
}

// Pen `TeHTQ` library card: wraps the group rows in a white container so
// the chip grid is visually distinct from the section background.
.lib-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  background: var(--rec-color-background);
  border: 1px solid #ede9fe;
  border-radius: 6px;
}

.lib-group {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.lib-group-name {
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #94a3b8;
}

.lib-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

// Available chip — pen `b3HIB` row 2+ pills: white fill, lavender outline,
// muted slate text. Hover hints at the eventual purple selected state.
.lib-tag {
  padding: 2px 6px;
  border-radius: 10px;
  background: var(--rec-color-background);
  border: 1px solid #ddd6fe;
  color: #64748b;
  font-size: 9px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: var(--rec-color-purple-bg);
    border-color: #c4b5fd;
    color: var(--rec-color-purple-fg);
  }
}

// Selected chip — pen `b3HIB` row 1 pills (#wildlife, #seafood, etc.):
// filled `#7C3AED` purple, white text. Tap toggles back to available.
.lib-tag-is-selected {
  background: #7c3aed;
  border-color: #7c3aed;
  color: #ffffff;

  &:hover {
    background: #6d28d9;
    border-color: #6d28d9;
    color: #ffffff;
  }
}

.empty {
  margin: 0;
  font-size: 9px;
  color: #94a3b8;
}

// Legend row for hashtag provenance (pen `k5MHiO`).
.legend {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 8px;
  color: #94a3b8;
  margin-left: 4px;
}

.legend-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-left: 6px;
}

.legend-dot-is-brief {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
}

.legend-dot-is-manual {
  background: #ffffff;
  border: 1px solid #c4b5fd;
}
